import React from 'react';

export default class SuperAdminTab extends React.Component {
  componentDidMount() {}

  constructor(props) {
    super(props);
  }

  render() {
    return (
      <div>
        <div className="limits">
          <ul className="set-list">
            <li className="setli">
              <span className="setli-tt">个人设置</span>
              <div className="set-in">
                <div className="simple-check spa-ui-group spaui-component">
                  <label className="spaui-checkbox">
                    <input type="checkbox" className="check" checked disabled name="" value="0" />
                    <span className="ico"></span>
                    <em className=" spaui-checkbox-text">个人基本信息设置</em>
                  </label>
                </div>
              </div>
            </li>
            <li className="setli">
              <span className="setli-tt">公海池</span>
              <div className="set-in">
                <div className="simple-check spa-ui-group spaui-component">
                  <label className="spaui-checkbox">
                    <input type="checkbox" className="check" checked disabled name="" value="0" />
                    <span className="ico"></span>
                    <em className=" spaui-checkbox-text">查看线索列表</em>
                  </label>
                  <label className="spaui-checkbox">
                    <input type="checkbox" className="check" checked disabled name="" value="0" />
                    <span className="ico"></span>
                    <em className=" spaui-checkbox-text">查看线索数据详情</em>
                  </label>
                  <label className="spaui-checkbox">
                    <input type="checkbox" className="check" checked disabled name="" value="0" />
                    <span className="ico"></span>
                    <em className=" spaui-checkbox-text">编辑线索数据详情</em>
                  </label>
                  <label className="spaui-checkbox">
                    <input type="checkbox" className="check" checked disabled name="" value="0" />
                    <span className="ico"></span>
                    <em className=" spaui-checkbox-text">导出线索数据</em>
                  </label>
                  <label className="spaui-checkbox">
                    <input type="checkbox" className="check" checked disabled name="" value="0" />
                    <span className="ico"></span>
                    <em className=" spaui-checkbox-text">分配线索</em>
                  </label>
                  <label className="spaui-checkbox">
                    <input type="checkbox" className="check" checked disabled name="" value="0" />
                    <span className="ico"></span>
                    <em className=" spaui-checkbox-text">电话外呼</em>
                  </label>
                  <label className="spaui-checkbox">
                    <input type="checkbox" className="check" checked disabled name="" value="0" />
                    <span className="ico"></span>
                    <em className=" spaui-checkbox-text">标记线索状态、线索评分</em>
                  </label>
                  <label className="spaui-checkbox">
                    <input type="checkbox" className="check" checked disabled name="" value="0" />
                    <span className="ico"></span>
                    <em className=" spaui-checkbox-text">线索导入</em>
                  </label>
                </div>
              </div>
            </li>
            <li className="setli">
              <span className="setli-tt">线索管理</span>
              <div className="set-in">
                <div className="simple-check spa-ui-group spaui-component">
                  <label className="spaui-checkbox">
                    <input type="checkbox" className="check" checked disabled name="" value="0" />
                    <span className="ico"></span>
                    <em className=" spaui-checkbox-text">查看线索列表</em>
                  </label>
                  <label className="spaui-checkbox">
                    <input type="checkbox" className="check" checked disabled name="" value="0" />
                    <span className="ico"></span>
                    <em className=" spaui-checkbox-text">查看线索数据详情</em>
                  </label>
                  <label className="spaui-checkbox">
                    <input type="checkbox" className="check" checked disabled name="" value="0" />
                    <span className="ico"></span>
                    <em className=" spaui-checkbox-text">编辑线索数据详情</em>
                  </label>
                  <label className="spaui-checkbox">
                    <input type="checkbox" className="check" checked disabled name="" value="0" />
                    <span className="ico"></span>
                    <em className=" spaui-checkbox-text">导出线索数据</em>
                  </label>
                  <label className="spaui-checkbox">
                    <input type="checkbox" className="check" checked disabled name="" value="0" />
                    <span className="ico" />
                    <em className=" spaui-checkbox-text">导出通话数据</em>
                  </label>
                  <label className="spaui-checkbox">
                    <input type="checkbox" className="check" checked disabled name="" value="0" />
                    <span className="ico"></span>
                    <em className=" spaui-checkbox-text">分配线索</em>
                  </label>
                  <label className="spaui-checkbox">
                    <input type="checkbox" className="check" checked disabled name="" value="0" />
                    <span className="ico"></span>
                    <em className=" spaui-checkbox-text">电话外呼</em>
                  </label>
                  <label className="spaui-checkbox">
                    <input type="checkbox" className="check" checked disabled name="" value="0" />
                    <span className="ico"></span>
                    <em className=" spaui-checkbox-text">标记线索状态、线索评分</em>
                  </label>
                  <label className="spaui-checkbox">
                    <input type="checkbox" className="check" checked disabled name="" value="0" />
                    <span className="ico"></span>
                    <em className=" spaui-checkbox-text">标记线索标签</em>
                  </label>
                </div>
              </div>
            </li>
            <li className="setli">
              <span className="setli-tt">会话管理</span>
              <div className="set-in">
                <div className="simple-check spa-ui-group spaui-component">
                  <label className="spaui-checkbox">
                    <input type="checkbox" className="check" checked disabled name="" value="0" />
                    <span className="ico"></span>
                    <em className=" spaui-checkbox-text">查看会话详情</em>
                  </label>
                </div>
              </div>
            </li>
            <li className="setli">
              <span className="setli-tt">团队设置</span>
              <div className="set-in">
                <div className="simple-check spa-ui-group spaui-component">
                  <label className="spaui-checkbox">
                    <input type="checkbox" className="check" checked disabled name="" value="0" />
                    <span className="ico"></span>
                    <em className=" spaui-checkbox-text">查看团队列表</em>
                  </label>
                  <label className="spaui-checkbox">
                    <input type="checkbox" className="check" checked disabled name="" value="0" />
                    <span className="ico"></span>
                    <em className=" spaui-checkbox-text">添加/编辑团队</em>
                  </label>
                  <label className="spaui-checkbox">
                    <input type="checkbox" className="check" checked disabled name="" value="0" />
                    <span className="ico"></span>
                    <em className=" spaui-checkbox-text">查看员工列表</em>
                  </label>
                  <label className="spaui-checkbox">
                    <input type="checkbox" className="check" checked disabled name="" value="0" />
                    <span className="ico"></span>
                    <em className=" spaui-checkbox-text">添加/编辑员工</em>
                  </label>
                </div>
              </div>
            </li>
            <li className="setli">
              <span className="setli-tt">角色权限</span>
              <div className="set-in">
                <div className="simple-check spa-ui-group spaui-component">
                  <label className="spaui-checkbox">
                    <input type="checkbox" className="check" checked disabled name="" value="0" />
                    <span className="ico"></span>
                    <em className=" spaui-checkbox-text">查看角色权限</em>
                  </label>
                  <label className="spaui-checkbox">
                    <input type="checkbox" className="check" checked disabled name="" value="0" />
                    <span className="ico"></span>
                    <em className=" spaui-checkbox-text">独立密码设置</em>
                  </label>
                  <label className="spaui-checkbox">
                    <input type="checkbox" className="check" checked disabled name="" value="0" />
                    <span className="ico"></span>
                    <em className=" spaui-checkbox-text">数据加密设置</em>
                  </label>
                </div>
              </div>
            </li>
            <li className="setli">
              <span className="setli-tt">线索管理设置</span>
              <div className="set-in">
                <div className="simple-check spa-ui-group spaui-component">
                  <label className="spaui-checkbox">
                    <input type="checkbox" className="check" checked disabled name="" value="0" />
                    <span className="ico"></span>
                    <em className="spaui-checkbox-text">分配设置</em>
                  </label>
                  <label className="spaui-checkbox">
                    <input type="checkbox" className="check" checked disabled name="" value="0" />
                    <span className="ico"></span>
                    <em className=" spaui-checkbox-text">短信通知设置</em>
                  </label>
                  <label className="spaui-checkbox">
                    <input type="checkbox" className="check" checked disabled name="" value="0" />
                    <span className="ico" />
                    <em className=" spaui-checkbox-text">微信提醒设置</em>
                  </label>
                  <label className="spaui-checkbox">
                    <input type="checkbox" className="check" checked disabled name="" value="0" />
                    <span className="ico" />
                    <em className=" spaui-checkbox-text">标签管理</em>
                  </label>
                </div>
              </div>
            </li>
            <li className="setli">
              <span className="setli-tt">线索转发设置</span>
              <div className="set-in">
                <div className="simple-check spa-ui-group spaui-component col-3">
                  <label className="spaui-checkbox">
                    <input type="checkbox" className="check" checked disabled name="" value="0" />
                    <span className="ico"></span>
                    <em className=" spaui-checkbox-text">查看多级字段拆解列表</em>
                  </label>
                  <label className="spaui-checkbox">
                    <input type="checkbox" className="check" checked disabled name="" value="0" />
                    <span className="ico"></span>
                    <em className=" spaui-checkbox-text">添加/编辑/删除多级字段拆解</em>
                  </label>
                  <label className="spaui-checkbox">
                    <input type="checkbox" className="check" checked disabled name="" value="0" />
                    <span className="ico"></span>
                    <em className=" spaui-checkbox-text">查看字段值映射配置列表</em>
                  </label>
                  <label className="spaui-checkbox">
                    <input type="checkbox" className="check" checked disabled name="" value="0" />
                    <span className="ico"></span>
                    <em className=" spaui-checkbox-text">查看字段值映射配置详情</em>
                  </label>
                  <label className="spaui-checkbox">
                    <input type="checkbox" className="check" checked disabled name="" value="0" />
                    <span className="ico"></span>
                    <em className=" spaui-checkbox-text">下载字段值映射配置</em>
                  </label>
                  <label className="spaui-checkbox">
                    <input type="checkbox" className="check" checked disabled name="" value="0" />
                    <span className="ico"></span>
                    <em className=" spaui-checkbox-text">添加/编辑/删除字段值映射配置</em>
                  </label>
                  <label className="spaui-checkbox">
                    <input type="checkbox" className="check" checked disabled name="" value="0" />
                    <span className="ico"></span>
                    <em className=" spaui-checkbox-text">查看推送接口配置列表</em>
                  </label>
                  <label className="spaui-checkbox">
                    <input type="checkbox" className="check" checked disabled name="" value="0" />
                    <span className="ico"></span>
                    <em className=" spaui-checkbox-text">查看推送接口配置详情</em>
                  </label>
                  <label className="spaui-checkbox">
                    <input type="checkbox" className="check" checked disabled name="" value="0" />
                    <span className="ico"></span>
                    <em className=" spaui-checkbox-text">添加/复制新建/编辑推送接口配置</em>
                  </label>
                  <label className="spaui-checkbox">
                    <input type="checkbox" className="check" checked disabled name="" value="0" />
                    <span className="ico"></span>
                    <em className=" spaui-checkbox-text">启用/暂停推送接口配置</em>
                  </label>
                  <label className="spaui-checkbox">
                    <input type="checkbox" className="check" checked disabled name="" value="0" />
                    <span className="ico"></span>
                    <em className=" spaui-checkbox-text">查看/复制推送测试内容</em>
                  </label>
                  <label className="spaui-checkbox">
                    <input type="checkbox" className="check" checked disabled name="" value="0" />
                    <span className="ico"></span>
                    <em className=" spaui-checkbox-text">推送接口配置推送验证</em>
                  </label>
                </div>
              </div>
            </li>
            <li className="setli">
              <span className="setli-tt">分析应用</span>
              <div className="set-in">
                <div className="simple-check spa-ui-group spaui-component">
                  <label className="spaui-checkbox">
                    <input type="checkbox" className="check" checked disabled name="" value="0" />
                    <span className="ico"></span>
                    <em className=" spaui-checkbox-text">线索数据分析</em>
                  </label>
                  <label className="spaui-checkbox">
                    <input type="checkbox" className="check" checked disabled name="" value="0" />
                    <span className="ico"></span>
                    <em className=" spaui-checkbox-text">上报规则设置</em>
                  </label>
                </div>
              </div>
            </li>
          </ul>
        </div>
        <div className="limits">
          <ul className="set-list">
            <li className="setli">
              <span className="setli-tt">数据范围</span>
              <div className="set-in">
                <div className="simple-check spa-ui-group spaui-component">
                  <label className="spaui-checkbox">
                    <input type="checkbox" className="check" checked disabled name="" value="0" />
                    <span className="ico"></span>
                    <em className=" spaui-checkbox-text">全公司</em>
                  </label>
                </div>
              </div>
            </li>
          </ul>
        </div>
      </div>
    );
  }
}
